// extracted by mini-css-extract-plugin
export default {"pattern-gradient":"Checkbox_pattern-gradient__ju8+p","box":"Checkbox_box__W9oVY"};